import { gql } from '@apollo/client';
import { type DocumentNode } from 'graphql';

export const GET_COMMUNITY: DocumentNode = gql`
  query community($id: String!) {
    community(id: $id) {
      id
      name
      url
      closed
      logoId
      logoFile {
        id
        name
        url
        hash
        extension
      }
      colors {
        link
        button
        voteBar
        userNavBg
      }
      options {
        translationLanguages
        livingLens {
          enabled
        }
        allowLanguageChoice
        allowedLanguages {
          name
          iso
        }
        showUserScores
        allowSocialMediaLinksInProfile
        anonymousSubmissionsEnabled
        allowSAML2Login
        allowAzureLogin
        allowCrowdicityLogin
        OpenIdProvider
        allowMessaging
        apiEnabled
        enableSlackIntegration
        twitterName
        twitterAllowFollow
        youtubeName
        youtubeAllowFollow
        facebookName
        facebookAllowFollow
        profileAvatarsDisabled
        appSwitcher {
          name
          url
          icon
        }
      }
      defaultAccess {
        users {
          user {
            id
            displayName
            screenName
            createdAt
            commentsCount
            firstName
            lastName
            profileImageId
            timezone
            votesCount
            profileImageFile {
              id
              name
              url
              hash
              extension
              userId
            }
          }
          canModerate
        }
        groups {
          usergroup {
            id
            name
          }
          canModerate
        }
      }
    }
  }
`;

export const GET_COUNTRIES: DocumentNode = gql`
  query getCountries($id: String!) {
    community(id: $id) {
      countries
    }
  }
`;
